<template>
    <list-page-shell title="待办件">
        <order-workbench :show-title="false" :extra-query-params="{ todo_list: 1 }" :auto-column-width="true" />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'TodoList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/TodoList.vue